import React, { Component } from 'react';
import InputPassword from '../components/input/InputPassword';
import { fetchPut } from '../cruds/remote';
import getLabel from '../translations/messages';
import { classNames } from '../functions/classNames';
import './Login.css';

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: '',
      newPassword: '',
      newPasswordRepeat: '',
      valid: false,
    };

  }

  handleChange = e => {
    let updated = { ...this.state };
    updated[e.target.name] = e.target.value;
    updated.warnMessage= '';

    this.setState(updated, this.handleBlur);
  };

  handleBlur = () => {
    const { newPassword, newPasswordRepeat } = this.state;

    if ( !newPassword || !newPasswordRepeat ) {
      this.setState({
        valid: false,
        error: '',
      });
    } else if( newPassword.length < 8 ) {
      this.setState({
        valid: false,
        warnMessage: getLabel(this.props.locale, 'changePassword.length'),
        error: '',
      });

    } else {
      if (newPassword !== newPasswordRepeat) {
        this.setState({
          valid: false,
          warnMessage: getLabel(this.props.locale, 'changePassword.notMatching'),
          error: '',
        });

      } else {
        this.setState({
          valid: true,
        });
      }

    }
  }

  handleSubmit = e => {
    e.preventDefault();
    const { valid, oldPassword, newPassword } = this.state;
    const { onSuccessfulChange } = this.props;

    if( valid ) {
      fetchPut('auth/passwordChange', { oldPassword, newPassword })
        .then(res => {
          if (res.value) {
            onSuccessfulChange();
          } else {
            this.setState({ error: getLabel(this.props.locale, 'changePassword.serverError') });
          }
        });

    }
  };

  render() {
    return (
      <div className="Login ChangePassword">
        <div className="login-container">
          <div className="login-content">
            <div className="login-header">
              <label className="headline1 darkGrayText"></label>
              <label className="headline1 orangeText">PHOENIX</label>
            </div>
            <div className="info">
              <p>{getLabel(this.props.locale, 'changePassword.message')}</p>
              <p>{getLabel(this.props.locale, 'changePassword.message2')}</p>
            </div>
            {this.state.error ? <div className="error">{this.state.error}</div> : ''}
            <form onSubmit={this.handleSubmit}>
              <InputPassword
                name="oldPassword"
                label="changePassword.old"
                handleChange={this.handleChange}
              />
              <InputPassword
                name="newPassword"
                label="changePassword.new"
                handleChange={this.handleChange}
                handleBlur={this.handleBlur}
              />
              <InputPassword
                name="newPasswordRepeat"
                label="changePassword.newRepeat"
                handleChange={this.handleChange}
                handleBlur={this.handleBlur}
              />
              <div>
                {this.state.warnMessage? <div className="warn">{this.state.warnMessage}</div> : ''}
                <button type="submit"
                    className={classNames('Button',
                                    'btn-orange',
                                    'changePasswordButton',
                                    (this.state.warnMessage? 'hasErrors' : '')
                              )}
                    disabled={this.state.valid ? '' : true}
                >
                  {getLabel(this.props.locale, 'changePassword.submit')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/main/pages/ChangePassword.js